import React, { useEffect, useState, useRef, lazy } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ConfigProvider, message, Modal } from 'antd';
// import CryptoJS from 'crypto-js';
import store from './redux/store';
import Admin from './routes/admin';
import Auth from './routes/auth';
import Logo from './static/img/Logo/LoadingLogo.png';
// import Loading from './static/img/Logo/splashScreen.mp4';
import { setEditCall } from './redux/CrmReduxCalls/EditNavCtrl';
import { findOneUserEmailConfiguration } from './Api/Services/EmailApiSevices';
import { getByUser, FetchUserDetails } from './Api/Services/UserApiService'
import { getCustomerSubcription } from './Api/Services/LicenceManagerApiServices'
import { findAllVectorizePropertyByCompanyCode, CompanyDataByUser, findAllCurrencyByCompany, LicenceUpdatesfromuser } from './Api/Services/CompanyApiService'
import { LogOutApi, getsyatemRolePermission, taskReminderAndOverdue, approvalRequestReminderAndOverdue, checkedAccountExpire } from './Api/Services/CommonApiService'
import { getCompanyCommunication } from './Api/Services/ProductConfigApiService';
import { CallProvider } from './container/dashboard/Pages/GlobalComponents/CallPage';
import { setUserData, clearUserData, } from './redux/CrmReduxCalls/LocalDataReduxStore';
import './static/css/style.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute'
import 'antd/dist/antd.less';

const ResetPassword = lazy(() => import('./routes/resetPassword'));

const { theme } = config;

function ProviderConfig({ setLoading }) {
  const publicRoutes = ["/Home/reset-password"];
  const stripeReturnPages = ["/Home/subcription-status"];
  const INACTIVITY_TIMEOUT = Number(process.env.REACT_APP_INACTIVITY_TIMEOUT)
  const inactivityTimer = useRef(null);
  const dispatch = useDispatch();
  const [isLoggedIn, setIsLogrdIn] = useState();
  const [accessToApp, setAccessToApp] = useState(false);
  const [redirectPath, setRedirectPath] = useState()
  const { rtl, topMenu, darkMode } = useSelector((state) => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });
  const [path, setPath] = useState(window.location.pathname);
  function resetTime(date) {
    date.setHours(0, 0, 0, 0); // Reset to midnight
    return date;
  }
  function extractTimeZoneName(tzString) {
    const parts = tzString.split(" ");
    return parts[1];
  }
  function isSameDate(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  const refrshScreen = () => {
    setAccessToApp(false);
    setLoading(false)
    dispatch(clearUserData());
    document.body.innerHTML = "";
    window.localStorage.removeItem('cx_expiration');
    window.localStorage.removeItem('cx_lastActivityTime');
    window.location.replace("/");
  }
  const forceLogout = (msg) => {
    if (msg) message.error(msg);
    const formData = {};
    try {
      LogOutApi(formData).catch(() => { // empty statement
      });
    } catch (_) {
      // empty statement
    }
    setTimeout(() => {
      refrshScreen()
    }, 3000);
  };
  const forceLogout2 = (titles, msg) => {
    if (msg) {
      Modal.info({
        title: (
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
            <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
            <span>{titles}</span>
          </div>
        ),
        icon: null,
        content: (
          <p>{msg}</p>
        ),
        className: "customice-confirm-modal",
        centered: true,
        okText: "OK",
        okButtonProps: {
          className: "button_colorsModal"
        },
        onOk() {
          const formData = {};
          try {
            LogOutApi(formData).catch(() => { });
          } catch (_) {
            // empty statement
          }
          setTimeout(() => {
            refrshScreen()
          }, 3000);
        },
      });
    }
  };
  const allowAccess = (userStatus) => {
    if (userStatus === 1) {
      setAccessToApp(true);
      setLoading(false);
    } else {
      return forceLogout("Your account is inactive, please contact your admin");
    }
  };
  const STATUS = {
    active: { label: "Active" },
    trialing: { label: "Trialing" },
    past_due: { label: "Past Due" },
    suspended: { label: "Suspended" },
    cancelled: { label: "Cancelled" },
    canceled: { label: "Cancelled" },
    expired: { label: "Expired" },
    no_Sub: { label: "No Subcription" },
  };
  async function handleAccountStatus(userStatus, roleName, profile, CompanyDetails) {
    try {
      const subscriptionData = await getCustomerSubcription(CompanyDetails?.companyCode)
      const subscription = Array.isArray(subscriptionData) ? subscriptionData[0] : subscriptionData
      if (subscription) {
        const StatusCheck = STATUS[subscription?.status] || STATUS.active;
        if (subscription?.plan?.isTrialPlan) {
          dispatch(setUserData({
            subcription: {
              subscriptionDetails: subscription,
              subscriptionPlan: subscription?.plan?.name,
              status: StatusCheck,
              isTrialPlan: subscription?.plan?.isTrialPlan,
              isActive: true
            }
          }));
          return allowAccess(userStatus);
        }
        if (roleName === "Administrator") {
          if (StatusCheck === "Cancelled") {
            setRedirectPath("/Home/subscription");
            dispatch(setUserData({
              subcription: {
                subscriptionDetails: subscription,
                subscriptionPlan: subscription?.plan?.name,
                status: StatusCheck,
                isTrialPlan: subscription?.plan?.isTrialPlan,
                isActive: false
              }
            }));
            return allowAccess(userStatus);
          }
          if (StatusCheck === "Suspended") {
            setRedirectPath("/Home/subscription");
            dispatch(setUserData({
              subcription: {
                subscriptionDetails: subscription,
                subscriptionPlan: subscription?.plan?.name,
                status: StatusCheck,
                isTrialPlan: subscription?.plan?.isTrialPlan,
                isActive: false
              }
            }));
            return allowAccess(userStatus);
          }
          dispatch(setUserData({
            subcription: {
              subscriptionDetails: subscription,
              subscriptionPlan: subscription?.plan?.name,
              status: StatusCheck,
              isTrialPlan: subscription?.plan?.isTrialPlan,
              isActive: true
            }
          }));
          return allowAccess(userStatus);
        }
        if (roleName !== "Administrator") {
          if (StatusCheck === "Cancelled") {
            return forceLogout2("Your subscription is no longer active", `Your data is safe. Renew your subscription to continue where you left off`);
            // Since you cancelled your plan, access ended on ${formattedDate}. 
          }
          if (StatusCheck !== "Expired" && StatusCheck !== "Suspended") {
            dispatch(setUserData({
              subcription: {
                subscriptionDetails: subscription,
                subscriptionPlan: subscription?.plan?.name,
                status: StatusCheck,
                isTrialPlan: subscription?.plan?.isTrialPlan,
                isActive: true
              }
            }));
            return allowAccess(userStatus);
          }
          return forceLogout("Your account has been suspended/expired. Please contact support or your company admin for assistance")
        }
        dispatch(setUserData({
          subcription: {
            subscriptionPlan: "Trial", status: "Trialing", isActive: true,
            isTrialPlan: subscription?.plan?.isTrialPlan, subscriptionDetails: subscription
          }
        }));
        return allowAccess(userStatus);
      }
      if (CompanyDetails?.companyCode === 1) {
        const data = await checkedAccountExpire()
        if (data && Object.keys(data).length > 0) {
          const subStatus = data?.status
          const tzString = profile?.timeZone || "(GMT+0:00) UTC";
          const tz = extractTimeZoneName(tzString);
          const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm");
          const currentDate = new Date(currentrealTime);
          if (data.subscriptionPlan === "Trial") {
            const endDate = new Date(data.endDate);
            const seventhDayBefore = new Date(endDate);
            seventhDayBefore.setDate(endDate.getDate() - 6);
            const resetCurrentDate = resetTime(new Date(currentDate));
            const resetEndDate = resetTime(new Date(endDate));
            if (isSameDate(currentDate, seventhDayBefore)) {
              if ((subStatus === "Expired" || subStatus === "Suspended" || subStatus === "Cancelled") && roleName === "Administrator") {
                dispatch(setUserData({
                  subcription: {
                    ...data,
                    subscriptionDetails: subscription,
                    isActive: false
                  }
                }));
                setRedirectPath("/Home/subscription");
                return allowAccess(userStatus);
              }
              return forceLogout("Your account is inactive, please contact your admin")
            }
            if (resetCurrentDate > resetEndDate) {
              if (subStatus === "Active" && roleName === "Administrator") {
                const response = await LicenceUpdatesfromuser(
                  { status: "Expired" },
                  data?.licenseManagementId
                );
                if (response.status === 200) {
                  dispatch(setUserData({
                    subcription: {
                      ...data,
                      subscriptionDetails: subscription,
                      isActive: false
                    }
                  }));
                  setRedirectPath("/Home/subscription");
                  return allowAccess(userStatus);
                }
              }
              if ((subStatus === "Expired" || subStatus === "Suspended" || subStatus === "Cancelled") && roleName === "Administrator") {
                dispatch(setUserData({
                  subcription: {
                    ...data,
                    subscriptionDetails: subscription,
                    isActive: false
                  }
                }));
                setRedirectPath("/Home/subscription");
                return allowAccess(userStatus);
              }
              return forceLogout("Your account is inactive, please contact your admin")
            }
            dispatch(setUserData({
              subcription: {
                ...data,
                subscriptionDetails: subscription,
                isActive: true
              }
            }));
            return allowAccess(userStatus);
          }
          if (roleName === "Administrator") {
            if (subStatus === "Cancelled") {
              const cancelDate = new Date(data.cancellationDate);
              const resetCurrentDate = resetTime(new Date(currentDate));
              const resetCancelDate = resetTime(new Date(cancelDate));
              if (resetCurrentDate <= resetCancelDate) {
                dispatch(setUserData({
                  subcription: {
                    ...data,
                    subscriptionDetails: subscription,
                    isActive: true
                  }
                }));
                return allowAccess(userStatus);
              }
              setRedirectPath("/Home/subscription");
              dispatch(setUserData({
                subcription: {
                  ...data,
                  subscriptionDetails: subscription,
                  isActive: false
                }
              }));
              return allowAccess(userStatus);
            }
            if (subStatus === "Suspended") {
              setRedirectPath("/Home/subscription");
              dispatch(setUserData({
                subcription: {
                  ...data,
                  subscriptionDetails: subscription,
                  isActive: false
                }
              }));
              return allowAccess(userStatus);
            }
            dispatch(setUserData({
              subcription: {
                ...data,
                subscriptionDetails: subscription,
                isActive: true
              }
            }));
            return allowAccess(userStatus);
          }
          if (roleName !== "Administrator") {
            if (subStatus === "Cancelled") {
              const cancelDate = new Date(data.cancellationDate);
              const resetCurrentDate = resetTime(new Date(currentDate));
              const resetCancelDate = resetTime(new Date(cancelDate));
              const formattedDate = data.cancellationDate.split("-").reverse().join("-");
              if (resetCurrentDate <= resetCancelDate) {
                dispatch(setUserData({
                  subcription: {
                    ...data,
                    subscriptionDetails: subscription,
                    isActive: true
                  }
                }));
                return allowAccess(userStatus);
              }
              return forceLogout2("Your subscription is no longer active", `Since you cancelled your plan, access ended on ${formattedDate}. Your data is safe. Renew your subscription to continue where you left off`);
            }
            if (subStatus !== "Expired" && subStatus !== "Suspended") {
              dispatch(setUserData({
                subcription: {
                  ...data,
                  subscriptionDetails: subscription,
                  isActive: true
                }
              }));
              return allowAccess(userStatus);
            }
            return forceLogout("Your account has been suspended. Please contact support or your company admin for assistance")
          }
        }
        dispatch(setUserData({
          subcription: { subscriptionPlan: "Trial", status: "Active", isActive: true, subscriptionDetails: subscription }
        }));
        return allowAccess(userStatus);
      }
    } catch (err) {
      return forceLogout("Your account is inactive, please contact your admin")
    }
  }
  async function getDetails() {
    if (isLoggedIn === undefined || isLoggedIn === null) {
      setAccessToApp(false);
      setLoading(false)
      return;
    }
    try {
      const userRes = await getByUser();
      if (userRes?.statusCode !== 200 || !userRes?.data?.userId) {
        forceLogout("Something went wrong. Please login again");
        return;
      }
      const {
        userId,
        roleId,
        roleName,
        userStatus,
      } = userRes.data;
      const [
        profile,
        Permission,
        CompanyDetails,
        Weekends,
      ] = await Promise.all([
        FetchUserDetails(userId),
        getsyatemRolePermission(roleId),
        CompanyDataByUser(),
        findAllCurrencyByCompany(),
      ]);
      let vectorInsert;
      const fallbackCurrency = {
        decimalOfCurrency: 2,
        currency: "USD",
        currencyName: "US Dollar",
        exchangeRate: 1,
        exchangeRateSetting: "Manual",
        refreshSchedule: "Not Applicable",
        symbol: "$",
      };
      const profileCurrency = profile?.data?.currency;
      if (CompanyDetails?.companyCode) {
        vectorInsert = await findAllVectorizePropertyByCompanyCode(
          CompanyDetails.companyCode
        );
      }
      const currencyData = (Array.isArray(Weekends) && Weekends?.length > 0) ? Weekends[0] : null;
      const companyDefaultCurrency = currencyData
        ? {
          decimalOfCurrency: currencyData.decimalOfCurrency ?? 2,
          ...(currencyData.currency?.[0] || fallbackCurrency),
        } : fallbackCurrency;
      const SelectedCurrency = currencyData && profileCurrency
        ? currencyData.currency?.find(
          (item) =>
            item.currency === profileCurrency.currency &&
            item.currencyName === profileCurrency.currencyName
        ) : null;
      const finalCurrency = currencyData
        ? {
          decimalOfCurrency: currencyData.decimalOfCurrency ?? 2,
          ...(SelectedCurrency || companyDefaultCurrency),
        } : fallbackCurrency;
      dispatch(setUserData({
        role: roleName,
        status: userStatus,
        permissions: Permission.permissions.permissions,
        profile: profile.data,
        currency: finalCurrency,
        defaultCurrecny: companyDefaultCurrency,
        company: CompanyDetails,
        vectorDb: vectorInsert
      }));
      taskReminderAndOverdue()
      approvalRequestReminderAndOverdue()
      await handleAccountStatus(userStatus, roleName, profile.data, CompanyDetails);
    } catch (error) {
      forceLogout("Something went wrong. Please login again");
    }
  }
  const fetchAll = async () => {
    await Promise.allSettled([
      getCompanyCommunication(),
      findOneUserEmailConfiguration(),
      getDetails(),
    ])
  };
  const SignOut = async () => {
    const formData = {};
    try {
      const response = await LogOutApi(formData)
      if (response.statusCode === 200) {
        message.warning("Your session has expired due to inactivity. Please log in again to continue");
        setTimeout(() => {
          refrshScreen()
        }, 3000);
      } else {
        message.error("Logout Failed");
      }
    } catch (err) {
      message.error("Logout Failed");
    }
  };
  const resetInactivityTimer = () => {
    localStorage.setItem("cx_lastActivityTime", Date.now().toString());
    if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
    inactivityTimer.current = setTimeout(() => {
      SignOut();
    }, INACTIVITY_TIMEOUT);
  };
  useEffect(() => {
    if (isLoggedIn) { // && accessToApp
      const activityEvents = [
        "mousemove",
        "mousedown",
        "keydown",
        "scroll",
        "touchstart",
        "click",
        "wheel"
      ];
      activityEvents.forEach((event) =>
        document.addEventListener(event, resetInactivityTimer, { passive: true })
      );
      resetInactivityTimer();
      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          const last = parseInt(localStorage.getItem("cx_lastActivityTime") || Date.now(), 10);
          if (Date.now() - last > INACTIVITY_TIMEOUT) {
            SignOut();
          } else {
            resetInactivityTimer();
          }
        }
      };
      window.addEventListener("focus", handleVisibilityChange);
      window.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        activityEvents.forEach((event) =>
          document.addEventListener(event, resetInactivityTimer, { passive: true })
          //  document.removeEventListener(event, resetInactivityTimer)
        );
        window.removeEventListener("focus", handleVisibilityChange);
        window.removeEventListener("visibilitychange", handleVisibilityChange);
        if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
      };
    }
  }, [isLoggedIn]); // , accessToApp
  useEffect(() => {
    if (isLoggedIn) {
      dispatch(setEditCall(false))
      fetchAll();
    }
  }, [dispatch, isLoggedIn]);
  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    const currentPath = window.location.pathname;
    const isPublic = publicRoutes.some((p) => currentPath.includes(p));
    if (isPublic) {
      dispatch(clearUserData());
      setAccessToApp(true);
    } else {
      // const urlToken = new URLSearchParams(window.location.search).get('token');
      // if (urlToken) {
      //   const expirationDate = new Date().getTime();
      //   const expirationDays = expirationDate + (2 * 60 * 60 * 1000)
      //   localStorage.setItem("cx_expiration", expirationDays);
      //   // setIsLogrdIn(urlToken)
      // } else {
      setIsLogrdIn(localStorage.getItem('cx_expiration'))
      // }
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath,]);
  const isPublic1 = publicRoutes.some((p) => path.includes(p));
  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Router basename={process.env.PUBLIC_URL}>
          <Route path="/Home/reset-password" component={ResetPassword} />
          {!isPublic1 && (<>
            {!accessToApp ? <Route path="/" component={Auth} /> : <ProtectedRoute path="/Home" component={Admin} />}
            {/* DEFAULT LOGIN REDIRECT (Old behaviour) */}
            {accessToApp &&
              !redirectPath &&
              (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) &&
              <Redirect to="/Home" />
            }
            {/* FORCED REDIRECT (Expired Subscription etc) */}
            {accessToApp &&
              redirectPath &&
              !stripeReturnPages.includes(path) &&
              path !== redirectPath &&
              <Redirect to={redirectPath} />
            }
          </>)}
        </Router>
      </ThemeProvider>
    </ConfigProvider >
  );
}

ProviderConfig.propTypes = {
  setLoading: PropTypes.func.isRequired,
};

function App() {
  const LoginToken = localStorage.getItem('cx_expiration');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!LoginToken) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [LoginToken]);
  const loadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5',
  };
  return (
    <Provider store={store}>
      <CallProvider>
        <div style={{ position: 'relative' }}>
          {loading && (
            <div style={loadingStyle}>
              <img src={Logo} alt="App Logo" style={{ width: '6%' }} />
            </div>
          )}
          <div style={{ display: loading ? 'none' : undefined }}>
            <ProviderConfig setLoading={setLoading} />
          </div>
        </div>
      </CallProvider>
    </Provider>
  );
}

export default hot(App);